import React from 'react'
import '../styles.css'
import { useNavigate} from 'react-router-dom';

export default function JoinSection(){
    const navigate = useNavigate();
    const navigateToSignup = () => {
     
      navigate('/signup');
    };
    return(
        <div id = "join-section">
            <p id = "join-text">Take control of your creativity and start writing like never before.</p>
            <button id = 'footer-join-btn' className='main-CTA' onClick={navigateToSignup}>Try Now</button>
        </div>
    )

}